import { useState, useEffect } from "react";

const FAVICON_MARK = "/favicon-192x192.png";

export function MicroSplash({ onComplete }) {
  const [state, setState] = useState("visible");

  useEffect(() => {
    // Check if already shown this session
    if (sessionStorage.getItem("steward-splash-shown")) {
      setState("hidden");
      onComplete?.();
      return;
    }

    // Check for reduced motion preference
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      sessionStorage.setItem("steward-splash-shown", "true");
      setState("hidden");
      onComplete?.();
      return;
    }

    // Phase timing: 400ms + 500ms + 300ms = 1200ms, extended to 1500ms for full impact
    const totalDuration = 1500;
    
    const exitTimer = setTimeout(() => {
      setState("exiting");
      sessionStorage.setItem("steward-splash-shown", "true");
    }, totalDuration);

    const hideTimer = setTimeout(() => {
      setState("hidden");
      onComplete?.();
    }, totalDuration + 300);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, [onComplete]);

  if (state === "hidden") return null;

  return (
    <div 
      className="micro-splash fixed inset-0 z-[9999] flex items-center justify-center" 
      data-state={state}
      aria-hidden="true"
      role="presentation"
      style={{ background: 'linear-gradient(180deg, #FDFCFA 0%, #F8F6F1 100%)' }}
    >
      <div className="flex flex-col items-center justify-center">
        {/* Icon */}
        <div className="splash-icon-container">
          <img 
            src={FAVICON_MARK} 
            alt="" 
            className="w-full h-full object-contain"
            aria-hidden="true"
          />
        </div>
        
        {/* Land geometry lines */}
        <div className="splash-geometry">
          <svg viewBox="0 0 200 60" preserveAspectRatio="xMidYMid meet">
            {/* Horizontal parcel lines */}
            <line x1="20" y1="15" x2="180" y2="15" className="geometry-line" />
            <line x1="40" y1="30" x2="160" y2="30" className="geometry-line" />
            <line x1="60" y1="45" x2="140" y2="45" className="geometry-line" />
            
            {/* Diagonal stewardship lines */}
            <line x1="30" y1="10" x2="70" y2="50" className="geometry-line" />
            <line x1="170" y1="10" x2="130" y2="50" className="geometry-line" />
            
            {/* Center accent line */}
            <line x1="70" y1="30" x2="130" y2="30" className="geometry-line-accent" />
          </svg>
        </div>

        {/* Scripture */}
        <div className="splash-scripture">
          <p className="splash-text-line1">"The Earth is the Lord's…</p>
          <p className="splash-text-line2">…and everything in it."</p>
          <p className="splash-reference">Psalm 24:1</p>
        </div>
      </div>
    </div>
  );
}
